var _rect, _rect2, _circle, _rect3, _rect4, _circle2, _rect5, _rect6, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLists = function SvgLists(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.2,
    height: 10.971,
    x: 21,
    y: 9,
    fill: "#2F68D1",
    rx: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 21.943,
    height: 10.971,
    x: 45,
    y: 9,
    fill: "#6C9BF1",
    rx: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.4,
    cy: 14.4,
    r: 6.4,
    fill: "#FF9D43"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 22.857,
    height: 10.971,
    x: 21,
    y: 30,
    fill: "#6C9BF1",
    rx: 2
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 18.286,
    height: 10.971,
    x: 49,
    y: 30,
    fill: "#B4CFFF",
    rx: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.4,
    cy: 35.4,
    r: 6.4,
    fill: "#FFD2A8"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 10.057,
    height: 10.971,
    x: 21,
    y: 51,
    fill: "#2F68D1",
    rx: 2
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 31.086,
    height: 10.971,
    x: 36,
    y: 51,
    fill: "#6C9BF1",
    rx: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.4,
    cy: 56.4,
    r: 6.4,
    fill: "#FFD2A8"
  })));
};
export default SvgLists;